import React, { Component } from 'react';
import Navbar from "../../components/Navbar";
import { apiAddress } from '../../services/api/map';
import Footer from "../../components/Footer";
import 'antd/dist/antd.css';
import { Pagination, Button, Input, Modal, notification } from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import { apiGetStoreList } from '../../services/api/store';

import GoogleMap from 'google-map-react';

import './style/store.scss';


const { Search } = Input;

const mapStyles = {
    width: '100%',
    height: '100%'
}

const markerStyle = {
    height: '30px',
    width: '80px',
    marginTop: '-50px'
}

const imgStyle = {
    height: '100%'
}

const titleStyle = {
    fontSize: '14px',
    fontFamily: 'KanitRegular'
}

var lat;
var lng;


class StoreList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            latDefault: 13.736717,
            lngDefault: 100.523186,
            nameAddress: "",
            current: 1,
            limit: 999,
            list_store: [],
            totaldata: 0
        };
    }

    componentDidMount() {

        navigator.geolocation.getCurrentPosition(function (position) {
            lat = position.coords.latitude
            lng = position.coords.longitude  
        });

        this.getStore(lat, lng)
        

    
    

        // navigator.geolocation.getCurrentPosition(function (position) {
        //     console.log('fff', position)
        // });
    }


    getNameAddress = async (lat, lng) => {
        let res = await apiAddress(lat, lng)

        if (res && res.status) {
            if (res.status == 200) {

                this.setState({
                    nameAddress: res.data.results[0].formatted_address,
                    
                })
            } else {
                notification.error({
                    message: 'แจ้งเตือนใหม่',
                    description:
                        'กรุณาลองใหม่อีกครั้ง',
                });
            }
        }
    }

    getStore = async (lat, lng) => {


        let page = this.state.current;
        let limit = this.state.limit;
        let res = await apiGetStoreList(lat, lng, page, limit)

        if (res && res.status) {
            if (res.status == 200) {
                this.setState({
                    list_store: res.data.result,
                    totaldata : res.data.result.length
                })
               
            } else {
                notification.error({
                    message: 'แจ้งเตือนใหม่',
                    description:
                        'ไม่สามารถแสดงร้านค้าได้ กรุราลองใหม่อีกครั้ง',
                });
            }
        }
    }


    onChange = page => {
        this.setState({
            current: page,
        });

        this.getStore(lat, lng)
    };

    onSearch = value => console.log(value);


    showModal = () => {

        this.setState({
            isModalVisible: true,
            latDefault: lat,
            lngDefault: lng
        })

        this.getNameAddress(lat, lng)
    };



    handleCancel = () => {
        this.setState({
            isModalVisible: false
        })
    };


    changeMarker = (e) => {

        this.setState({
            latDefault: e.lat,
            lngDefault: e.lng
        })


        this.getNameAddress(e.lat, e.lng)

    }

    renderSwitch(param) {
        switch(param) {
          case 'SWEET':
            return 'ของหวาน';
            case 'DRINK':
            return 'เครื่องดื่ม';
            case 'SNACK':
            return 'ของทานเล่น';
            case 'DISH':
            return 'อาหารคาว';
            case 'SELL':
            return 'ร้านขายของชำ';
            case 'OTHER':
            return 'อื่นๆ';
          default:
            return 'อาหารคาว';
        }
      }


    render() {

        const Marker = ({ title }) => (
            <div style={markerStyle}>
                <img style={imgStyle} src="/img/icon/location.png" alt={title} />
                <h3 style={titleStyle}>{title}</h3>
            </div>
        );




        return (
            <div className="cover-store">
                <div className="wh-bg">
                    <div className="container">
                        <Navbar />
                    </div>
                </div>

                <div className="box-store container">
                    <div className="list-group">
                        <div className="row record-group">
                            <div className="col-lg-2 col-md-2 col-4 type">
                                <div className="img-group">
                                    <img src="/img/group/drink.png" alt="" className="img-fluuid" />
                                </div>
                                <p className="name-group">เครื่องดื่ม</p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-4 type">
                                <div className="img-group">
                                    <img src="/img/group/dessert.png" alt="" className="img-fluuid" />
                                </div>
                                <p className="name-group">ของหวาน</p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-4 type">
                                <div className="img-group">
                                    <img src="/img/group/snack.png" alt="" className="img-fluuid" />
                                </div>
                                <p className="name-group">ของทานเล่น</p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-4 type">
                                <div className="img-group">
                                    <img src="/img/group/dish.png" alt="" className="img-fluuid" />
                                </div>
                                <p className="name-group">อาหารคาว</p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-4 type">
                                <div className="img-group">
                                    <img src="/img/group/sell.png" alt="" className="img-fluuid" />
                                </div>
                                <p className="name-group">ร้านขายของชำ</p>
                            </div>
                            <div className="col-lg-2 col-md-2 col-4 type">
                                <div className="img-group">
                                    <img src="/img/group/other.png" alt="" className="img-fluuid" />
                                </div>
                                <p className="name-group">อื่นๆ</p>
                            </div>
                        </div>
                    </div>
                    <div className="address">
                        <div className="bx-grid">
                            <div className="tab-location">
                                <Button type="primary" onClick={this.showModal}><img src="/img/icon/location.png" alt="" className="img-fluid" /> จัดส่งที่ <span className="namelocation">{this.state.nameAddress}</span></Button>
                            </div>
                            <div className="tab-search">
                                <Search className="bx-search" placeholder="ค้นหาร้านได้ที่นี่!" onSearch={this.onSearch} style={{ width: 200 }} />
                            </div>
                        </div>
                    </div>
                    <div className="bx-list-store">
                        <p className="hd-store">ร้านค้าทั้งหมด</p>
                        <hr className="brhd" />
                        <div className="row bx-all">

                            {
                                this.state.list_store ? this.state.list_store.map(v => {

  
                                    return <div key={v.merchant_id} className="col-lg-3 col-md-3 col-12 col-store">
                                    <a href={`/detail/${v.merchant_id}`} className="link-detail">
                                        <div className="img-store">
                                            <img src={v.merchant_image != "https://nippy.imsoftware.dev" ? v.merchant_image : "/img/pic/store.png"} alt="" className="img-fluid" />
                                        </div>
                                        <div className="detail-store">
                                            <p className="name-store">{v.name}</p>
                                            <div className="row detail">
                                                <div className="col-lg-4 col-mg-4 col-4 type-txt">
                                                    <p className="type-group">{this.renderSwitch(v.merchant_type)}</p>
                                                    <FontAwesomeIcon className="circle-txt" icon={['fas', 'circle']} />
                                                </div>
                                                <div className="col-lg-4 col-mg-4 col-4 type-txt">
                                                    <p className="type-group">{v.distance} กม.</p>
                                                    <FontAwesomeIcon className="circle-txt" icon={['fas', 'circle']} />
                                                </div>
                                                <div className="col-lg-4 col-mg-4 col-4">
                                                    <p className="type-group"><img src="/img/icon/delivery-man.png" alt="" className="img-fluid delivery" /> ฿{v.shiping_price}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                }) : null
                            }
                            
                            
                        </div>
                        {/* <div className="page">
                            <Pagination current={this.state.current} onChange={this.onChange} total={this.state.totaldata} />
                        </div> */}
                    </div>

                    <Modal className="modal-map" title="สถานที่ที่คุณอยู่" visible={this.state.isModalVisible} onCancel={this.handleCancel} footer={false}>
                        <div className="bx-map">
                            <GoogleMap


                                style={mapStyles}
                                bootstrapURLKeys={{ key: 'AIzaSyC8bJru_qVoe0XgT1xmBD7rygLVUxq7FwY' }}
                                center={{
                                    lat: this.state.latDefault,
                                    lng: this.state.lngDefault
                                }}
                                zoom={19}
                                onClick={(e) => { this.changeMarker(e) }}
                            >

                                <Marker
                                    title={'current location'}
                                    lat={this.state.latDefault}
                                    lng={this.state.lngDefault}

                                >
                                </Marker>
                            </GoogleMap>
                        </div>
                    </Modal>
                </div>
                <Footer />
            </div>
        )
    }
}

export default StoreList;
